import { Form, Typography } from "antd";
import { NamePath } from "antd/es/form/interface";
const { Text } = Typography;

interface FormFieldViewEditProps {
  label: React.ReactNode;
  name?: NamePath;
  value?: React.ReactNode;
  isEdit?: boolean;
  children?: React.ReactNode;
}

const FormFieldViewEdit = ({
  label,
  name,
  value,
  isEdit,
  children,
}: FormFieldViewEditProps) => {
  return (
    <Form.Item
      label={
        <span className="text-[var(--textBlack56)] leading-5">{label}</span>
      }
      name={name}
      className="mb-0 w-full"
    >
      {isEdit ? (
        children
      ) : (
        <Text className="font-medium text-black text-[14px]">
          {value || "---"}
        </Text>
      )}
    </Form.Item>
  );
};

export default FormFieldViewEdit;
